import useTheme from '../utils/useTheme';
import {
  ACCENT, ACCENT_FOND, AMBRE, AMBRE_BG, AMBRE_FG, CIBLE, NEUTRE, RAYON_BOUTON, RAYON_GROUPE, REMPLISSAGE,
  ROUGE, ROUGE_BG, ROUGE_FG, SUR_ACCENT, SURFACE, TEXTE, TEXTE_SECONDAIRE, VERT, VERT_BG, VERT_FG, OMBRE_CARTE,
} from '../theme';

/**
 * Briques d'interface communes à tous les écrans. Un seul endroit pour l'anatomie d'un bouton,
 * d'une capsule ou d'un en-tête : les écrans ne restylent pas ces éléments à la main.
 */

// ---------- Icônes (traits arrondis, 1,8 px, alignées sur la taille du texte) ----------

function Svg({ taille = 20, children, epaisseur = 1.9 }) {
  return (
    <svg width={taille} height={taille} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={epaisseur} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
      {children}
    </svg>
  );
}

export const Icone = {
  ChevronGauche: (p) => <Svg {...p} epaisseur={2.4}><path d="M15 5l-7 7 7 7" /></Svg>,
  ChevronDroite: (p) => <Svg {...p} epaisseur={2.2}><path d="M9 5l7 7-7 7" /></Svg>,
  ChevronHaut: (p) => <Svg {...p} epaisseur={2.2}><path d="M5 15l7-7 7 7" /></Svg>,
  ChevronBas: (p) => <Svg {...p} epaisseur={2.2}><path d="M5 9l7 7 7-7" /></Svg>,
  Croix: (p) => <Svg {...p} epaisseur={2.2}><path d="M6 6l12 12M18 6L6 18" /></Svg>,
  Soleil: (p) => <Svg {...p} epaisseur={1.9}><circle cx="12" cy="12" r="4.2" /><path d="M12 2.5v2.2M12 19.3v2.2M2.5 12h2.2M19.3 12h2.2M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M5.3 18.7l1.6-1.6M17.1 6.9l1.6-1.6" /></Svg>,
  Lune: (p) => <Svg {...p} epaisseur={1.9}><path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z" /></Svg>,
  Image: (p) => <Svg {...p} epaisseur={1.6}><rect x="3" y="3" width="18" height="18" rx="4" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" /></Svg>,
  Lecture: (p) => <Svg {...p}><path d="M8 5.5v13l10.5-6.5z" fill="currentColor" stroke="none" /></Svg>,
  Clavier: (p) => <Svg {...p} epaisseur={1.7}><rect x="2" y="6" width="20" height="12" rx="3" /><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M8 14h8" /></Svg>,
  Pave: (p) => <Svg {...p} epaisseur={1.7}><rect x="4" y="3" width="16" height="18" rx="3" /><path d="M8 8h.01M12 8h.01M16 8h.01M8 12h.01M12 12h.01M16 12h.01M8 16h.01M12 16h4" /></Svg>,
  Planche: (p) => <Svg {...p} epaisseur={1.7}><path d="M9 4L4 6v14l5-2 6 2 5-2V4l-5 2-6-2z" /><path d="M9 4v14M15 6v14" /></Svg>,
  Agrandir: (p) => <Svg {...p}><path d="M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7" /></Svg>,
  Nuage: (p) => <Svg {...p} epaisseur={1.8}><path d="M7 18h10a4 4 0 0 0 .6-7.95A6 6 0 0 0 6.1 10.5 3.75 3.75 0 0 0 7 18z" /></Svg>,
  Fleche: (p) => <Svg {...p}><path d="M5 12h14M13 6l6 6-6 6" /></Svg>,
  Sortie: (p) => <Svg {...p} epaisseur={1.8}><path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3M10 17l5-5-5-5M15 12H4" /></Svg>,
  Attention: (p) => <Svg {...p} epaisseur={1.9}><path d="M12 3.5L2.5 20h19L12 3.5z" /><path d="M12 10v4.5M12 17.2h.01" /></Svg>,
  Coche: (p) => <Svg {...p} epaisseur={2.4}><path d="M5 12.5l4.5 4.5L19 7.5" /></Svg>,
  Poignee: (p) => <Svg {...p} epaisseur={2.6}><path d="M8 12h8" /></Svg>,
  Reduire: (p) => <Svg {...p} epaisseur={2.2}><path d="M6 12h12" /></Svg>,
};

// ---------- Boutons ----------

const VARIANTES = {
  plein: { background: ACCENT, color: SUR_ACCENT, classe: 'aqs-pressable aqs-pressable-plein' },
  succes: { background: VERT, color: '#FFFFFF', classe: 'aqs-pressable aqs-pressable-plein' },
  teinte: { background: ACCENT_FOND, color: ACCENT, classe: 'aqs-pressable' },
  gris: { background: REMPLISSAGE, color: TEXTE, classe: 'aqs-pressable' },
  surface: { background: SURFACE, color: TEXTE, classe: 'aqs-pressable', ombre: OMBRE_CARTE },
  danger: { background: ROUGE_BG, color: ROUGE_FG, classe: 'aqs-pressable' },
  texte: { background: 'transparent', color: ACCENT, classe: 'aqs-pressable aqs-pressable-leger' },
};

/**
 * Bouton unique de l'app. `variante` : plein | succes | teinte | gris | surface | danger | texte.
 * La hauteur ne descend jamais sous la cible tactile ; `icone` seule (sans enfants) donne un
 * bouton carré.
 */
export function Bouton({ variante = 'gris', hauteur = CIBLE, icone, children, style, disabled, className = '', ...reste }) {
  const v = VARIANTES[variante] || VARIANTES.gris;
  const carre = icone && (children == null || children === false);
  return (
    <button
      type="button"
      disabled={disabled}
      className={`${v.classe} ${className}`}
      style={{
        flex: 'none', height: hauteur, minWidth: hauteur, padding: carre ? 0 : '0 16px', borderRadius: RAYON_BOUTON,
        border: 'none', background: v.background, color: v.color, boxShadow: v.ombre,
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 7,
        fontSize: 16, fontWeight: 600, letterSpacing: '-0.005em', whiteSpace: 'nowrap',
        cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.4 : 1,
        ...style,
      }}
      {...reste}
    >
      {icone}
      {children}
    </button>
  );
}

/** Retour façon barre de navigation : chevron + nom de l'écran précédent, en couleur d'accent. */
export function BoutonRetour({ libelle, onClick, style }) {
  return (
    <button
      type="button"
      className="aqs-pressable aqs-pressable-leger"
      onClick={onClick}
      style={{
        minHeight: CIBLE, padding: '0 8px 0 0', marginLeft: -6, border: 'none', background: 'none',
        display: 'inline-flex', alignItems: 'center', gap: 2, fontSize: 17, color: ACCENT, cursor: 'pointer',
        textAlign: 'left', maxWidth: '100%', ...style,
      }}
    >
      <Icone.ChevronGauche taille={24} />
      <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{libelle}</span>
    </button>
  );
}

/**
 * Contrôle segmenté : le curseur glisse d'un segment à l'autre plutôt que de sauter, pour qu'on
 * voie d'où l'on part et où l'on arrive.
 */
export function ControleSegmente({ options, valeur, onChange, hauteur = 40, style }) {
  const index = Math.max(options.findIndex((o) => o.valeur === valeur), 0);
  const n = options.length;
  return (
    <div
      role="tablist"
      style={{
        position: 'relative', display: 'grid', gridTemplateColumns: `repeat(${n}, minmax(0, 1fr))`,
        padding: 3, borderRadius: 11, background: REMPLISSAGE, minWidth: 0, ...style,
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute', top: 3, bottom: 3, left: 3, width: `calc((100% - 6px) / ${n})`,
          borderRadius: 9, background: SURFACE, boxShadow: '0 3px 8px rgba(0,0,0,0.12), 0 3px 1px rgba(0,0,0,0.04)',
          transform: `translateX(${index * 100}%)`, transition: 'transform 380ms var(--aqs-courbe)',
        }}
      />
      {options.map((o) => {
        const on = o.valeur === valeur;
        return (
          <button
            key={o.valeur}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => onChange(o.valeur)}
            className="aqs-pressable aqs-pressable-leger"
            style={{
              position: 'relative', minWidth: 0, height: hauteur - 6, padding: '0 14px', border: 'none',
              background: 'none', fontSize: 15, fontWeight: on ? 650 : 500, color: TEXTE, cursor: 'pointer',
              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
              transition: 'font-weight 200ms ease',
            }}
          >
            {o.libelle}
          </button>
        );
      })}
    </div>
  );
}

// ---------- Capsules d'état ----------

export const TONS = {
  vert: { fond: VERT_BG, texte: VERT_FG, point: VERT },
  orange: { fond: AMBRE_BG, texte: AMBRE_FG, point: AMBRE },
  rouge: { fond: ROUGE_BG, texte: ROUGE_FG, point: ROUGE },
  accent: { fond: ACCENT_FOND, texte: ACCENT, point: ACCENT },
  neutre: { fond: REMPLISSAGE, texte: TEXTE_SECONDAIRE, point: NEUTRE },
};

/** Petite capsule colorée : état d'un lot, d'une pièce, d'une file. */
export function Capsule({ ton = 'neutre', point = false, children, style }) {
  const t = TONS[ton] || TONS.neutre;
  return (
    <span
      style={{
        flex: 'none', height: 26, padding: '0 10px', display: 'inline-flex', alignItems: 'center', gap: 6,
        borderRadius: 13, background: t.fond, color: t.texte, fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {point && <span style={{ width: 7, height: 7, borderRadius: '50%', background: t.point, flex: 'none' }} />}
      {children}
    </span>
  );
}

// ---------- Mise en page ----------

/** Groupe « inset » : une surface arrondie qui réunit des lignes séparées par un filet. */
export function Groupe({ children, style }) {
  return (
    <div style={{ background: SURFACE, borderRadius: RAYON_GROUPE, overflow: 'hidden', boxShadow: OMBRE_CARTE, ...style }}>
      {children}
    </div>
  );
}

/**
 * En-tête d'un niveau de liste : retour optionnel au-dessus, grand titre, sous-titre, et un
 * visuel à gauche (vignette du modèle) quand le niveau porte sur une commande précise.
 */
export function EnTeteSection({ retour, titre, sousTitre, visuel, droite }) {
  return (
    <div style={{ minWidth: 0 }}>
      {retour}
      <div style={{ marginTop: retour ? 2 : 0, display: 'flex', alignItems: 'center', gap: 16, minWidth: 0 }}>
        {visuel}
        <div style={{ flex: 1, minWidth: 0 }}>
          <h1 className="aqs-grand-titre" style={{ margin: 0, color: TEXTE }}>{titre}</h1>
          {sousTitre && (
            <p className="aqs-para" style={{ margin: '6px 0 0', fontSize: 16, color: TEXTE_SECONDAIRE }}>{sousTitre}</p>
          )}
        </div>
        {droite}
      </div>
    </div>
  );
}

/**
 * Bascule clair / sombre. L'icône montre le mode vers lequel on VA (lune en clair, soleil en
 * sombre) et les deux icônes se relaient par une rotation, sans saut.
 */
export function BoutonTheme({ variante = 'gris', hauteur = 40, style }) {
  const [theme, basculer] = useTheme();
  const sombre = theme === 'sombre';
  const libelle = sombre ? 'Passer en mode clair' : 'Passer en mode sombre';
  const icone = (visible, enfant) => (
    <span
      aria-hidden="true"
      style={{
        position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
        opacity: visible ? 1 : 0, transform: visible ? 'none' : 'rotate(-90deg) scale(0.6)',
        transition: 'opacity 240ms ease, transform 420ms var(--aqs-courbe)',
      }}
    >
      {enfant}
    </span>
  );
  return (
    <Bouton
      variante={variante}
      hauteur={hauteur}
      onClick={basculer}
      aria-label={libelle}
      title={libelle}
      icone={(
        <span style={{ position: 'relative', width: 20, height: 20, display: 'inline-block' }}>
          {icone(!sombre, <Icone.Lune taille={19} />)}
          {icone(sombre, <Icone.Soleil taille={20} />)}
        </span>
      )}
      style={{ borderRadius: hauteur / 2, ...style }}
    />
  );
}
